module.exports = __webpack_public_path__ + "media/scholarship_winners/rachel-e-d37936b3.png";